import { useMics } from "@/lib/mics";

// Which microphone to record. Shown beside the level meter so the effect of a switch is visible straight away.
export const MicPicker = ({ value, onChange, stream, online = false }) => {
  const mics = useMics(stream);
  if (mics.length < 2 && !value) return null; // one mic: nothing to choose
  const label = online ? "Your microphone" : "Microphone";
  return (
    <select
      value={mics.some((m) => m.id === value) ? value : ""}
      onChange={(e) => onChange(e.target.value)}
      aria-label={label}
      title={`${label}. Switching starts a new audio chunk; nothing is lost.`}
      className="h-8 max-w-[11rem] truncate bg-[var(--o-bg)] border border-[var(--o-border)] px-2 font-mono text-[11px] outline-none hover:border-[var(--o-border-strong)] focus:border-[var(--o-fg)]"
      data-testid="mic-select"
    >
      <option value="">System default</option>
      {mics.map((m) => <option key={m.id} value={m.id}>{m.label}</option>)}
    </select>
  );
};
